import React from 'react';
import styles from './ScanArea.module.css';

interface ScanAreaProps {
  onClick: () => void;
}

export const ScanArea: React.FC<ScanAreaProps> = ({ onClick }) => {
  return (
    <div className={styles.scanZone} onClick={onClick} role="button" tabIndex={0}>
      <div className={styles.iconWrapper}>
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 14V8C4 6.93913 4.42143 5.92172 5.17157 5.17157C5.92172 4.42143 6.93913 4 8 4H14" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M34 4H40C41.0609 4 42.0783 4.42143 42.8284 5.17157C43.5786 5.92172 44 6.93913 44 8V14" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M44 34V40C44 41.0609 43.5786 42.0783 42.8284 42.8284C42.0783 43.5786 41.0609 44 40 44H34" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M14 44H8C6.93913 44 5.92172 43.5786 5.17157 42.8284C4.42143 42.0783 4 41.0609 4 40V34" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M4 24H44" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <rect x="14" y="12" width="4" height="24" rx="1" fill="#3B82F6" opacity="0.5" />
          <rect x="20" y="12" width="2" height="24" rx="1" fill="#3B82F6" opacity="0.5" />
          <rect x="24" y="12" width="3" height="24" rx="1" fill="#3B82F6" opacity="0.5" />
          <rect x="29" y="12" width="5" height="24" rx="1" fill="#3B82F6" opacity="0.5" />
        </svg>
      </div>
      <p className={styles.title}>Tap to scan UPC of Product</p>
      <p className={styles.subtitle}>Point device camera at barcode</p>
    </div>
  );
};
